// eslint-disable-next-line import/prefer-default-export
export const MODAL_TITLE_ERROR = 'Error!';
